import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocCutomEntitiesCreate extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Create Custom RegEx</h3>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V1_REGEX_INSERT}
                </code>
                <div className="description">
                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                    <br/>
                    <b>Create Custom RegEx</b><br/>
                    <br/>
                    The insert endpoint allows for a user to insert new regular expression patterns. This will perform validation on the input data before adding. All patterns MUST be valid before becoming active. The response will return any and all warnings (if applicable) but the input data must be corrected before the insert will be successful.
                    <br />
                    On success there is no need for a server reload. These patterns should show up in your enrich call.
                    <br/>
                    <div className="note">
                        <span className="fa fa-info-circle">&nbsp;</span>
                        Due to the stateless manner of the server, sometimes the sync may take a minute before appearing in an enrich call.
                    </div>
                </div>

                <h4 className="heading-2">Request</h4>

                <h4 className="heading-3" id="enrichv2_request_object">Request object</h4>
                A Custom RegEx JSON Object is sent as the payload. The following link has a complete documentation for the <Link to="/documentation/doc_customregex#top">Custom RegEx Fields</Link>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">entries</td>
                        <td className="meaning">A list of Custom RegEx JSON Objects to extract in the output.
                        </td>
                        <td className="type">entry[]<br/>
                        Custom RegEx schema documentation is found <Link to="/documentation/doc_customregex#custom_regex_entry_object">here</Link><br/></td>
                        {/* entries schema documentation is found <Link to="/documentation/doc_kbattributes">here</Link><br/></td> */}
                        <td className="type">
                            Required
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                    POST {urlHandler.API_ENDPOINT_V1_REGEX_INSERT}<br/>
                    Accept: application/JSON<br/>
                    Authorization: Bearer [YOUR-API-KEY]<br/>
                    Content-Type: application/json<br/>
                    <br/>
                    {JSON.stringify(examples.EXAMPLE_REQUEST_REGEX_INSERT, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Response</h4>

                <h4 className="heading-3">Response object</h4>
                <div className="description">
                    The response object contains a information on the status of the Custom RegEx change as well as accessory information about the change.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">code</td>
                        <td className="meaning">A specific code indicating a success or failure.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">message</td>
                        <td className="meaning">A simple message about what was completed.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>details</i></td>
                        <td className="meaning">A list of details regarding any issues with the request. May be empty if the request is a success.</td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_REGEX_INSERT, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-3">Error Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_REGEX_INSERT_ERROR, null, 3)}
                    </pre>
                </div>
            </div>
        );
    }
}

export default DocCutomEntitiesCreate;